<input matInput maxlength="20" [mask]="mask" [thousandSeparator]="authService.thousandSeparator" [leadZero]="true"
  [decimalMarker]="authService.decimalMarker" [prefix]="currency ? currency : ''" [readonly]="readonly"
  [placeholder]="placeholder" [formControl]="amount">